<h1 class="soft-text-xl mt-2 mb-3 mr-2 ml-2">Abholdatum anpassen</h1>

<div class="c mt-3">
    <soft-date-input #dateInput [value]="currentDate" (valueChange)="currentDate = ($event ?? '')"></soft-date-input>
</div>

<div class="c row space-between no-wrap center-v mt-3">
    <button class="soft-button soft-button-secondary custom-button mr-2" (click)="close('DISMISSED')">Abbrechen</button>
    <button class="soft-button primary custom-button ml-2"
            [disabled]="!dateInput.value || dateInput.value?.length < 1 || !currentDate"
            (click)="close({ abholdatum: currentDate ?? '' })">
        Speichern
    </button>
</div>
